(ns common.resource.query.service-key
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn roles->role-options [roles]
  (->> (->clj roles)
       (filter #(some #{"advertiser"} (:allowed-scopes %)))
       (map #(hash-map :label (:name %) :value %))
       vec))

(defn roles-query []
  #js {:queryKey  #js ["v2-roles"]
       :queryFn   (fn [_] (qhttp/get (qhttp/render :api/auth-v2-roles {})))
       :select roles->role-options
       :staleTime (* 5 60 1000)})

(defn service-keys-query [{:keys [advertiser-id]}]
  #js {:queryKey #js ["service-keys" advertiser-id]
       :queryFn  (fn [_] (qhttp/get (qhttp/render :api/service-keys {} {:advertiser-id advertiser-id})))
       :enabled  (boolean advertiser-id)})

(defn create-service-key-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["create-service-key"]
       :mutationFn  (fn [payload]
                      (qhttp/post (qhttp/render :api/service-keys {}) {:body payload}))
       :onSuccess   (fn [_]
                      (invalidate-queries {:queryKey ["service-keys" advertiser-id]}))
       :onError     (fn [^js response]
                      (rf/dispatch [:response-handler/handle-response
                                    {:entity-name "Service Key"
                                     :type        :error
                                     :message     "Failed to create service key"
                                     :response    (->clj response)}]))})

(defn revoke-service-key-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["revoke-service-key"]
       :mutationFn  (fn [service-key-id]
                      (qhttp/delete (qhttp/render :api/service-key
                                                  {:service-key-id service-key-id})))
       :onSuccess   (fn [_]
                      (invalidate-queries {:queryKey ["service-keys" advertiser-id]}))
       :onError     (fn [^js response]
                      (rf/dispatch [:response-handler/handle-response
                                    {:entity-name "Service Key"
                                     :type        :error
                                     :message     "Failed to revoke service key"
                                     :response    (->clj response)}]))})
